import Home from "@/views/public/Home.vue";

export default {
  path: "/carta",
  name: "carta",
  component: Home
};
